import Vue from 'vue'
import Router from 'vue-router'
import bottomBar from '@/components/bottomBar'
import largephoto from '@/components/largephoto'
import mainPage from '@/pages/mainPage'
import scalarlist from '@/pages/scalarlist'
import userinfo from '@/pages/userinfo'
import scalarinfo from '@/pages/scalarinfo'
import login from '@/pages/login'
import question from '@/pages/question'
import result from '@/pages/result'
import addchild from '@/pages/addchild'
import delay from '@/pages/delay'
import selectinfomation from '@/pages/selectinfomation'
import thank from '@/pages/thank'
import reportList from '@/pages/reportList'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/bottomBar',
      name: 'bottomBar',
      component: bottomBar
    },
    {
      path: '/mainPage',
      name: 'mainPage',
      component: mainPage
    },
    {
      path: '/scalarlist',
      name: 'scalarlist',
      component: scalarlist
    },
    {
      path: '/userinfo',
      name: 'userinfo',
      component: userinfo
    },
    {
      path: '/scalarinfo',
      name: 'scalarinfo',
      component: scalarinfo
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/question',
      name: 'question',
      component: question
    },
    {
      path: '/largephoto',
      name: 'largephoto',
      component: largephoto
    },
    {
      path: '/result',
      name: 'result',
      component: result
    },
    {
      path: '/addchild',
      name: 'addchild',
      component: addchild
    },
    {
      path: '/selectinfomation',
      name: 'selectinfomation',
      component: selectinfomation
    },
    {
      path: '/delay',
      name: 'delay',
      component: delay
    },
    {
      path: '/thank',
      name: 'thank',
      component: thank
    },
    {
      path: '/reportList',
      name: 'reportList',
      component: reportList
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js